import React, { useState, useEffect } from "react";
import "./ApiDoc.css";
import Navbar from "./Navbar"

const ApiDoc = () => {
  const [openEndpoints, setOpenEndpoints] = useState([]);

  const toggleEndpoint = (key) => {
    setOpenEndpoints((prevState) =>
      prevState.includes(key)
        ? prevState.filter((item) => item !== key)
        : [...prevState, key]
    );
  };
    useEffect(() => {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      scrollToTop()
    }, [])
  const userEndpoints = [
    {
      method: "GET",
      url: "/users/profile",
      description: "Vrací profil uživatele včetně všech jeho rezervací a detailů o podniku, kde byly rezervace provedeny.",
      auth: "Bearer userToken", 
      request: "/users/profile?userId={userId}",
      response: `{
  "_id": "abc123",
  "name": "abc",
  "phone": "731000111",
  "email": "email",
  "__v": "0"
}`
    },
    {
      method: "GET",
      url: "/users/basicReservation",
      description: "Vrátí seznam rezervací zadaného uživatele.",
      auth: "Bearer userToken",
      request: "/users/basicReservation?userId={userId}",
      response: `{
  "reservations": [
    {
      "_id": "abc123",
      "business": {
        "_id": "abc123",
        "name": "abc"
        },
      "date": "2025-03-10T23:00:00.000Z",
      "time": "12:00",
      "numberOfPeople": "123",
      "status": "abc"
    },
    {
      '_id': "abc123",
      "business": {
        "_id": "abc123",
        "name": "abc"
      },
      "date": "2025-03-10T23:00:00.000Z",
      "time": "15:00",
      "numberOfPeople": "123",
      "status": "abc"
    },
  ]
}`
},
    {
      method: "GET",
      url: "/users/slotReservation",
      description: "Vrací všechny rezervace pro daného uživatele včetně informací o firmě a službě.",
      auth: "Bearer userToken",
      request: "/users/slotReservation?userId={userId}",
      response:` {
"reservations": [
  {
  "_id": "abc123",
  "business": {
    "_id": "abc123",
    "name": "abc"
  },
  "service": {
    "_id": "abc123",
    "name": "abc",
    "price": "123"
  },
  "date": "2025-03-25T23:00:00.000Z",
  "timeSlots": [
    {
    "available": "false",
    "endTime": "10:15",
    "startTime": "10:00",
    "_id": "abc123"
    },
    {
    "available": "false",
    "endTime": "10:30",
    "startTime": "10:15",
    "_id": "abc123"
    },
    ], 
  "status": "abc"
  }
  ]
}`
    },
    {
      method: "GET",
      url: "/users/bookingReservation",
      description: "Vrací všechny hotelové rezervace pro daného uživatele včetně detailů o podniku a rezervaci.",
      auth: "Bearer userToken",
      request: "/users/bookingReservation?userId={userId}",
      response:` {
  "reservations": [
    {
      "_id": "abc123",
      "checkInTime": "15:00",
      "checkOutTime": "12:00",
      "status": "abc",
      "description": "abc",
      "business": {
        "name": "abc"
      },
      "reservations": [
        {
          "checkInDate": "2025-03-16T23:00:00.000Z",
          "checkOutDate": "2025-03-19T23:00:00.000Z",
          "numberOfPeople": "123",
          "status": "abc",
          "_id": "abc123"
        },
        {
          "checkInDate": "2025-03-19T23:00:00.000Z",
          "checkOutDate": "2025-03-21T23:00:00.000Z",
          "numberOfPeople": "123",
          "status": "abc",
          "_id": "abc123"
        },
      ]
    }
  ]
},`
    },
    {
      method: "POST",
      url: "/users/register",
      description: "Zaregistruje nového uživatele. Vyžaduje souhlas s podmínkami.",
      auth: "no auth",
      request: `{
  "name": "abc",
  "email": "email",
  "phone": "731000111",
  "password": "sercret_password",
  "termsAndConditions": true
}`,
      response: `{
  "message": "Uživatel úspěšně registrován"
}`,
    },
    {
      method: "POST",
      url: "/users/login",
      description: "Přihlásí uživatele a vrátí JWT token v případě úspěšného přihlášení.",
      auth: "no auth",
      request: `{
  "email": "email",
  "password": "secret_pasword"
}`,
      response: `{
  "userToken": "abc123"
}`,

    },
    {
      method: "POST",
      url: "/users/forgot-password",
      description: "Odešle na e-mail uživatele odkaz pro resetování hesla.",
      auth: "no auth",
      request: `{
  "email": "email"
}`,
      "response": `{
  "message": "E-mail s instrukcemi pro změnu hesla byl odeslán."
}`,
    },
    {
      method: "POST",
      url: "/users/reset-password",
      description: "Nastaví nové heslo uživateli na základě platného reset tokenu.",
      auth: "no auth",
      request: `{
  "resetToken": "abc123",
  "newPassword": "new_secret_password"
}`,
      response: `{
  "message": "Heslo bylo úspěšně změněno."
}`,
    },
    {
      method: "PUT",
      url: "/users/update-profile",
      description: "Aktualizuje profil uživatele na základě poskytnutých údajů (jméno, email, telefon).",
      auth: "Bearer userToken",
      request: `{
  "userId": "abc123",
  "name": "abc",
  "email": "email",
  "phone": "731000111"
}`,
      response: `{
  "message": "Profil úspěšně aktualizován",
  "user": {
  "_id": "abc123",
  "name": "abc",
  "email": "email",
  "phone": "731000112"
  }
}`
    },
    // Přidejte další endpointy podle potřeby...
  ];
  const endpoints = [
    {
      method: 'GET',
      url: '/reservation/availableslots',
      description: 'Získá dostupné časové sloty pro rezervace na základě ID podniku.',
      auth: 'no auth',
      request: '/reservation/availableslots?businessId={businessId}',
      response: `
{
  "availableDates": [
    {
      "date": "2025-04-02",
      "dayOfWeek": "Čtvrtek",
      "workHours": [
        { "startTime": "08:00", "endTime": "10:00", "available": true },
        { "startTime": "10:00", "endTime": "12:00", "available": false }
      ]
    }
  ]
}`,
    },
    {
      method: "GET",
      url: "/reservation/list",
      description: "Získá seznam rezervací pro uživatele nebo podnik.",
      request: "/reservation/list?businessId={businessId}",
      auth: "Bearer businessToken",
      response: `
"message": "Rezervace potvrzena", 
{
  "reservations": [
    {
      "_id": "67e26ae681014033a8b28e2c",
      "user / quest": {
        "_id": "abc123",
        "name": "abc",
        "phone": "731000111",
        "email": "email"
        },
      "business": {
        "_id": "abc123",
        "name": "Business Name"
        },
      "service": {
        "_id": "abc123",
        "name": "Melírování",
        "description": "Částečné nebo celkové melírování pro přirozený vzhled.",
        "price": "123",
        "duration": "123",
        "business": "abc123",
        "__v": 0
            },
      "date": "2025-03-24T23:00:00.000Z",
      "timeSlots": [
        {"_id": "abc123", "startTime": "08:00", "endTime": "08:15", "available": false},
        {"_id": "abc123", "startTime": "08:15", "endTime": "08:30", "available": false},
        {"_id": "abc123", "startTime": "08:30", "endTime": "08:45", "available": false},
        {"_id": "abc123", "startTime": "08:45", "endTime": "09:00", "available": false},
      ],
      "status": "abc",
      "expiresAt": "2026-03-24T23:00:00.000Z",
      "createdAt": "2025-03-25T08:35:50.896Z",
      "updatedAt": "2025-03-25T08:38:22.038Z",
      "__v": 0
    }
  ]
}`
    },
    {
      method: 'POST',
      url: '/reservation/create',
      description: 'Vytvoří novou rezervaci pro uživatele.',
      auth: 'Bearer userToken', 
      request: `{
  "user": "12345",
  "business": "abc123",
  "service": "Kadeřnictví",
  "date": "2025-04-05",
  "timeSlots": [
    { "startTime": "10:00", "endTime": "12:00" }
  ]
}`,
      response: `{
  "message": "Rezervace vytvořena",
  "reservation": {
    "id": 2,
    "user": "12345",
    "business": "abc123",
    "service": "Kadeřnictví",
    "date": "2025-04-05",
    "timeSlots": [
      { "startTime": "10:00", "endTime": "12:00" }
    ]
  }
}`,
    },
    {
      method: 'POST',
      url: '/reservation/business-create',
      description: 'Vytvoří rezervaci (pauzu) bez přiřazeného uživatele — např. přestávka nebo blokace času.',
      auth: 'Bearer businessToken',
      request: `{
  "business": "abc123",
  "date": "05.04.2025",
  "timeSlots": [
    "10:00 - 12:00"
  ]
}`,
      response: `{
"message": "Nepřítomnost vytvořena",
"reservation": {
  "id": 10,
  "business": "abc123",
  "date": "2025-04-05T00:00:00.000Z",
  "timeSlots": [
      {
      "startTime": "10:00",
      "endTime": "12:00",
      "available": false
      }
    ]
  }
}`
    },
    {
      method: 'POST',
      url: '/reservation/business-create-with-name',
      description: 'Vytvoří rezervaci na konkrétní jméno bez registrace uživatele (např. telefonická rezervace).',
      auth: 'Bearer businessToken',
      request: `{
  "name": "Jan Novák",
  "business": "abc123",
  "service": "Kadeřnictví",
  "date": "05.04.2025",
  "timeSlots": [
    "10:00 - 12:00"
  ]
}`,
      response: `{
"message": "Rezervace vytvořena",
"reservation": {
  "id": 11,
  "name": "Jan Novák",
  "business": "abc123",
  "service": "Kadeřnictví",
  "date": "2025-04-05T00:00:00.000Z",
  "timeSlots": [
      {
      "startTime": "10:00",
      "endTime": "12:00",
      "available": false
      }
    ]
  }
}`
    },
    {
      method: 'POST',
      url: '/reservation/quest-create',
      description: 'Vytvoří novou rezervaci pro hosta.',
      request: `{
  "quest": {
    name: "abc",
    email: "email",
    phone: "731000111",
    },
  "business": "abc123",
  "service": "Guided Tour",
  "date": "2025-04-10",
  "timeSlots": [
    { "startTime": "09:00", "endTime": "11:00", "available": true },
    { "startTime": "11:00", "endTime": "13:00", "available": true }
  ]
}`,
      response: `
"message": "Rezervace vytvořena",
{
  "reservation": {
    "id": 2,
    "quest": {
      "name": "abc",
      "email": "email",
      "phone": "731000111",
      },
    "business": "abc123",
    "service": "Kadeřnictví",
    "date": "2025-04-05",
    "timeSlots": [
      { "startTime": "10:00", "endTime": "12:00" }
    ]
  }
}`,
auth: "no auth",
    },
    {
      method: "PUT",
      url: "/reservation/confirm/:id",
      description: "Potvrzuje rezervaci pro daný podnik.",
      request: "/reservation/confirm/{id}",
      auth: "Bearer businessToken",
      response: 
      `
message: "Rezervace potvrzena",      
{
  _id: abc123,
  user: abc123,
  business: abc123,
  service:abc123,
  date: 2025-04-03T22:00:00.000Z,
  timeSlots: [
    {
      startTime: '09:45',
      endTime: '10:00',
      available: false,
      _id: abc123
    },
    {
      startTime: '10:00',
      endTime: '10:15',
      available: false,
      _id: abc123
    },
    {
      startTime: '10:15',
      endTime: '10:30',
      available: false,
      _id: abc123
    }
  ],
  status: 'confirmed',
  expiresAt: 2026-04-03T22:00:00.000Z,
  createdAt: 2025-04-04T06:56:22.711Z,
  updatedAt: 2025-04-04T06:57:32.378Z,
  __v: 0
}
`
    },
    {
      method: "DELETE",
      url: "/reservation/cancel/:id",
      description: "Potvrzuje rezervaci pro daný podnik.",
      request: "/reservation/cancel/{id}",
      auth: "Bearer businessToken",
      body: `{
        "business": "abc123"  
      }`,
      response: 
      `{
  message: "Rezervace potvrzena",
  _id: abc123,
  user: abc123,
  business: abc123,
  service:abc123,
  date: 2025-04-03T22:00:00.000Z,
  timeSlots: [
    {startTime: '09:45', endTime: '10:00', available: false, _id: abc123},
    {startTime: '10:00', endTime: '10:00', available: false, _id: abc123},
    {startTime: '09:45', endTime: '10:00', available: false, _id: abc123},
    {startTime: '09:45', endTime: '10:00', available: false, _id: abc123},
  ]
}
`
    },
    // Přidejte další endpointy podle potřeby...
  ];

  const basicEndpoints = [
    {
      method: 'GET',
      url: '/basic-reservation/available-slots',
      description: 'Získá dostupné časové sloty pro rezervace na základě ID podniku.',
      request: '/reservation/availableslots?businessId={businessId}', // Používá se businessId jako query parametr
      auth: 'no auth',
      response: `
[
  {
    "date": "2025-04-02",
    "dayOfWeek": "Čtvrtek",
    "workHours": [
      { "startTime": "08:00", "endTime": "08:15" },
      { "startTime": "08:15", "endTime": "08:30" },
    ]
  }
]`,

    },
    {
      method: 'GET',
      url: '/basic-reservation/list',
      description: 'Získá všechny rezervace pro podnik.',
      request: '/basic-reservation/list?businessId={businessId}', 
      auth: 'Bearer businessToken',
      response: `
{
  "_id": 123,
  "user / quest": {
    "_id": ""abc123"",
    "name": "abc",
    "phone": "731000111",
    "email": "email",
    "__v": "0"
    },
  "business": "123",
  "date": "2025-03-10T23:00:00.000Z",
  "time": "12":00,
  "numberOfPeople": "123",
  "item": '',
  "status": '"abc"',
  "expiresAt": 2026-"03"-10T23:00:00.000Z,
  "__v": "0"
},`,

    },
    {
      method: 'POST',
      url: '/basic-reservation/create',
      description: 'Vytvoří novou rezervaci pro uživatele.',
      auth: 'Bearer userToken',
      request: `{
  "user": "12345",
  "business": "abc123",
  "item": "",
  "date": "2025-04-05",
  "time": "12:30"
}`,
      response: `{
  "message": "Rezervace vytvořena",
  "reservation": {
    "id": 2,
    "user": "12345",
    "business": "abc123",
    "item": "",
    "date": "2025-04-05",
    "time": "12:30"
  }
}`,
    },
    {
      method: 'POST',
      url: '/basic-reservation/quest-create',
      description: 'Vytvoří novou rezervaci pro hosta.',
      auth: 'Bearer userToken',
      request: `{
  "quest": {
    "name": "abc",
    "email": "email",
    "phone": "731000111"
    },
  "business": "abc123",
  "item": "",
  "date": "2025-04-05",
  "time": "12:30"
}`,
      response: `
"message": "Rezervace vytvořena",
{
  "reservation": {
    "id": 2,
    "quest": {
      "name": "abc",
      "email": "email",
      "phone": "731000111"
    },
    "business": "abc123",
    "item": "",
    "date": "2025-04-05",
    "time": "12:30"
  }
}`,
    },
    {
      method: "PUT",
      url: "/basic-reservation/confirm/:id",
      description: "Potvrdí rezervaci pro podnik.",
      request: "/basic-reservation/confirm/{id}?businessId={businessId}",
      auth: "Bearer businessToken",
      body: `{
  "business": "abc123"
}`,
      response: `
{
  "_id": "123",
  "user / quest": {
    "_id": "abc123",
    "name": "abc",
    "phone": "731000111",
    "email": "email",
    "__v": 0
    },
  "business": "123",
  "date": "2025-03-10T23:00:00.000Z",
  "time": "12:00",
  "numberOfPeople": 123,
  "item": "",
  "status": "confirmed",
  "expiresAt": "2026-03-10T23:00:00.000Z",
  "__v": 0
}
      `
    },
    {
      method: "DELETE",
      url: "/basic-reservation/cancel/:id",
      description: "Zruší rezervaci pro podnik.",
      request: "/basic-reservation/cancel/{id}",
      auth: "Bearer businessToken",
      body: `{
  "business": "abc123"
}`,
      response: `
{
  "_id": "123",
  "user / quest": {
    "_id": "abc123",
    "name": "abc",
    "phone": "731000111",
    "email": "email",
    "__v": 0
    },
  "business": "123",
  "date": "2025-03-10T23:00:00.000Z",
  "time": "12:00",
  "numberOfPeople": 123,
  "item": "",
  "status": "cancelled",
  "expiresAt": "2026-03-10T23:00:00.000Z",
  "__v": 0
}
      `
    }

    
    // Přidejte další endpointy podle potřeby...
  ];
  const bookingEndpoints = [
    {
      method: 'GET',
      url: '/booking/unavailable-dates',
      description: 'Získá nedostupné dny pro rezervace na základě ID podniku.',
      request: '/booking/unavailable-dates?businessId={businessId}', // Používá se businessId jako query parametr
      auth: 'no auth',
      response: `
{
  "2025-03-16 PM",
  "2025-03-17",
  "2025-03-18",
  "2025-03-19 AM",
}`,

    },
    {
      method: 'GET',
      url: '/booking/list',
      description: 'Získá rezervace na základě ID podniku.',
      request: '/booking/list?businessId={businessId}', // Používá se businessId jako query parametr
      auth: 'businessToken',
      response: `
{
  reservations: {
    "_id": "123",
    "business": "123",
    "reservations": [
      {
        "_id": "123"
        "checkInDate": "2025-03-16T23:00:00.000Z",
        "checkOutDate": "2025-03-19T23:00:00.000Z",
        "createdAt": "2025-03-11T11:53:05.407Z",
        "dog": "false",
        "expiresAt": "2026-03-16T23:00:00.000Z",
        "numberOfPeople": "123",
        "paid": "false",
        "status": "abc",
        "totalPrice": "123",
        "updatedAt": "2025-03-12T09:31:40.770Z",
        "user": {
          "email": "email",
          "name": "abc",
          "phone": "731000111",
          "__v": 0,
          },
        "__v": "0",
      },
    ],
    "checkInTime": "00:00",
    "checkOutTime": "00:00",
    "maxPeople": "123",
    "pricePerNight": "123",
    "pet": "true",
    "petFee": "123",
    "cleaningFee": "123",
    deposit": "123",
    "accountNumber": "120210210/1012",
    "description": "abc",
    "createdAt": "2025-03-10T07:54:26.241Z",
    "updatedAt": "2025-04-03T06:48:05.934Z",
    "__v": "0"
  }
}`,

    },
    {
      method: 'POST',
      url: '/booking/create',
      description: 'Vytvoří novou rezervaci pro uživatele.',
      auth: 'Bearer userToken',
      request: `{
reservation: {
  "checkInDate": "2025-03-16",
  "checkOutDate": "2025-03-19",
  "numberOfPeople": "123",
  "dog": "true"
  },
  business: 'abc123',
  user: 'abc123'
}
        `,
      response: `
"message": "Rezervace vytvořena"
{
  "payments": {
    "accountNumber": "123",
    "depositAmount":" 123",            
    "paymentMethod": "Bankovní převod",
    "remainingAmount": "123",
    "totalAmount": "123",
    "variableSymbol": "123",
  }
  "reservation": {
    "_id": "123",
    "user": "abc123",
    "business": "abc123",
    "dog": "true",
    "checkInDate": "2025-03-16",
    "checkOutDate": "2025-03-19",
    "paid": "false",
    "status": "pending",
    "numberOfPeople": "123",
    "totalPrice": "123",
    "variableSymbol": "123",
    "createAt": "2025-04-03",
    "expiresAt": "2026-03-17",
  }
}`,
    },
    {
      method: 'POST',
      url: '/booking/quest-create',
      description: 'Vytvoří novou rezervaci hosta.',
      auth: 'no auth',
      request: `{
  reservation: {
    "checkInDate": "2025-05-05",
    "checkOutDate": "2025-05-08",
    "numberOfPeople": "5",
    "dog": "true"
    },
  business: 'abc123',
  quest: {
    "name": "abc",
    "phone": "731000111",
    "email": "email",
  }
}
        `,
      response: `
"message": "Rezervace vytvořena"
{
  "payments": {
    "accountNumber": "123",
    "depositAmount":" 123",            
    "paymentMethod": "Bankovní převod",
    "remainingAmount": "123",
    "totalAmount": "123",
    "variableSymbol": "123",
  }
  "reservation": {
    "_id": "123",
    "quest": {
      "name": "abc",
      "phone": "731000111",
      "email": "email",
    },
    "business": "abc123",
    "dog": "true",
    "checkInDate": "2025-05-05",
    "checkOutDate": "2025-05-08",
    "paid": "false",
    "status": "pending",
    "numberOfPeople": "123",
    "totalPrice": "123",
    "variableSymbol": "123",
    "createAt": "2025-04-03",
    "expiresAt": "2026-05-06",
  }
}`,
    },
    {
      method: "PUT",
      url: "/booking/confirm/:id",
      description: "Potvrdí rezervaci na základě ID rezervace.",
      auth: "Bearer businessToken",
      request: `
      {
        "business": "abc123"
      }`,
      response: `
{
  "message": "Rezervace potvrzena",
  "status": "success",
}`
    },
    {
      method: "DELETE",
      url: "/booking/cancel/:id",
      description: "Zruší rezervaci na základě ID rezervace.",
      auth: "Bearer businessToken",
      request: "/booking/cancel/12345?business=abc123",
      response: `{
  "message": "Rezervace zrušena"
  "status": "success",
}`
    },

    // Přidejte další endpointy podle potřeby...
  ];
const businessEndpoints = [
  {
    method: "POST",
    url: "/business/login",
    description: "Přihlášení firmy. Vrací JWT token, pokud jsou přihlašovací údaje správné.",
    request: `{
  "email": "email",
  "password": "secret_password"
}`,
    response: `{
  "businessToken": "abc123",
  "message": "Přihlášení úspěšné."
}`
  },
  {
    method: "POST",
    url: "/business/profile/services/add",
    description: "Přidá novou službu k firmě. Je potřeba mít platný business token.",
    auth: "Bearer businessToken",
    request: `{
  "name": "Masáž zad",
  "description": "Relaxace pro záda a krční páteř.",
  "price": "690",
  "duration": "60"
}`,
    response: `{
  "message": "Služba byla úspěšně přidána.",
  "service": {
    "_id": "abc123",
    "name": "Masáž zad",
    "description": "Relaxace pro záda a krční páteř.",
    "price": "690",
    "duration": "60",
    "business": "abc123",
    "__v": 0
  }
}`,

  },
  {
    method: "POST",
    url: "/business/forgot-password",
    description: "Odešle e-mail s odkazem na resetování hesla dané firmy.",
    request: `{
  "email": "email"
}`,
    response: `{
  "message": "E-mail s instrukcemi pro změnu hesla byl odeslán."
}`,
  },
  {
  method: "POST",
  url: "/business/reset-password",
  description: "Změní heslo firmy na základě resetovacího tokenu.",
  request: `{
  "resetToken",
  "newPassword": "new_secret-password"
}`,
  response: `{
  "message": "Heslo bylo úspěšně změněno."
  }`,
  },
  {
    method: "GET",
    url: "/business/public/:businessId",
    description: "Vrací veřejná data firmy podle jejího ID. Včetně služeb, dostupných termínů a viditelnosti jednotlivých sekcí.",
    request: "/business/public/:businessId",
    auth: "no auth",
    response: `{
  "_id": "abc123",
  "name": "abc",
  "ic": "12345678",
  "phone": "731000111",
  "email": "email",
  "owner": "abc",
  "businessType": "abc",
  "street": "Karlova",
  "houseNumber": "12",
  "city": "Praha",
  "postalCode": "11000",
  "country": "Česká republika",
  "description": "<p style="font-weight:bold;">Nabízíme profesionální masáže v centru Prahy.</p>",
  "workHours": [
    {
      "day": "Pondělí",
      "end": "18:00",
      "start": "09:00"
    },
      ...
  ]
  "visiblePhoto": true,
  "visibleWorkHours": true,
  "visibleDescription": true,
  "visibleCompanyData": true,
  "visibleMap": false,
  "visibleServices": true,
  "basicReservation": true,
  "salonReservation": true,
  "hotelReservation": false,
  "services": [
    {
      "_id": "abc123",
      "name": "abc",
      "price": 123,
      "description": "abc",
      "duration": 60
    },
      ...
  ]
}`,
  },
  {
    method: "PUT",
    url: "/business/profile",
    description: "Aktualizace profilu firmy. Vyžaduje autentizaci pomocí JWT tokenu. Prazdná nebo 'undefined' pole se ignorují.",
    auth: "Bearer businessToken",
    request: `{
  "name": "Masáže Praha",
  "owner": "Jana Nováková",
  "ic": "12345678",
  "dic": "CZ12345678",
  "email": "kontakt@masazepraha.cz",
  "phone": "+420123456789",
  "description": "Nabízíme profesionální masáže v centru Prahy.",
  "street": "Karlova",
  "houseNumber": "12",
  "city": "Praha",
  "postalCode": "11000",
  "workHours": [
    {
      "day": "monday",
      "start": "09:00",
      "end": "17:00"
    },
    {
      "day": "tuesday",
      "start": "09:00",
      "end": "17:00"
    },
      ...
  ]
}`,
    response: `{
  message: "Profil aktualizován"
}`

  },
  {
    method: "PUT",
    url: "/business/profile/description",
    description: "Aktualizace popisu firmy. V popisu jsou odstraněny všechny výskyty 'style:'. Popis je povinný a nemůže být prázdný.",
    auth: `Bearer businessToken`,
    request: `{
  "description": "<p style={"color: red;"}>Tento popis obsahuje html kód</p>"
}`,
    response: `{
  message: "Popis aktualizován"
}`,
  },
  {
    method: "PUT",
    url: "/business/reservation-update",
    description: "Aktualizace nastavení zobrazení na hlavní stránce",
    auth: "Bearer businessToken",
    request: `{
  "businessId": "abc123",
  "updateData": {
    "basicReservation": true,
    "salonReservation": false,
    "hotelReservation": true,
    "homepage": true,
    "visiblePhoto": true,
    "visibleWorkHours": true,
    "visibleDescription": true,
    "visibleCompanyData": true,
    "visibleMap": true,
    "visibleServices": true
  }
}`,
    response: `{
      "message": "Aktualizace proběhla v pořádku"
    }`
  },
  
  {
    method: "DELETE",
    url: "/business/profile/services/:serviceId/delete",
    description: "Smaže konkrétní službu firmy podle ID. Musí být přihlášený business uživatel (token).",
    auth: "Bearer businessToken",
    request: "/business/profile/services/abc123/delete",
    response: `{
  "message": "Služba byla úspěšně odstraněna."
}`,
  },

]


  return (
    <div>
      <Navbar />
    <div className="api-container">
      <nav className="navbar">
        <h1>API Dokumentace</h1>
      </nav>

      <div className="content">
        <section className="section">
          <h2>Úvod</h2>
          <p>Toto API slouží pro správu rezervací a questů. Poskytuje CRUD operace pro různé služby a rezervace.</p>
        </section>

        <section className="section">
          <h2>Autentizace</h2>
          <p>Pro používání API je nutné zasílat autentizační token v hlavičce požadavku. Existují dva typy tokenů:</p>

          <h3>User Token</h3>
          <p>Pro uživatele, který provádí operace týkající se rezervací.</p>
          <pre className="code-block">
            {`GET /api/reservations{"\n"}
Headers: {"\n"}
Authorization: Bearer USER_TOKEN`}
          </pre>

          <h3>Business Token</h3>
          <p>Pro administrátory firem, kteří provádějí operace týkající se dostupných slotů nebo jiných administrativních akcí.</p>
          <pre className="code-block">
            {`GET /business/reservation/availableslots{"\n"}
Headers: {"\n"}
Authorization: Bearer BUSINESS_TOKEN`}
          </pre>
        </section>

        <section className="section">
          <h2>Endpointy pro uživatele</h2>
{userEndpoints.map((endpoint, index) => {
  const key = `services-${index}`; // Přidání unikátního klíče
  return (
    <div key={key} className="endpoint">
      <h3
        className="endpoint-header"
        onClick={() => toggleEndpoint(key)}
        style={{ cursor: 'pointer' }}
      >
        <span className={`method ${endpoint.method.toLowerCase()}`}>{endpoint.method}</span> {endpoint.url}
      </h3>

      {openEndpoints.includes(key) && (
        <>
          <p>{endpoint.description}</p>
          <p><strong>Autentizace:</strong> {endpoint.auth}</p>
          <pre className="code-block">{`Request:\n${endpoint.auth}\n${endpoint.request}`}</pre>
          <pre className="code-block">{`Response:\n${endpoint.response}`}</pre>
        </>
      )}
    </div>
  );
})}
</section>
        <section className="section">
          <h2>Endpointy pro podniky a podnikající osoby</h2>
{businessEndpoints.map((endpoint, index) => {
  const key = `services-${index}`; // Přidání unikátního klíče
  return (
    <div key={key} className="endpoint">
      <h3
        className="endpoint-header"
        onClick={() => toggleEndpoint(key)}
        style={{ cursor: 'pointer' }}
      >
        <span className={`method ${endpoint.method.toLowerCase()}`}>{endpoint.method}</span> {endpoint.url}
      </h3>

      {openEndpoints.includes(key) && (
        <>
          <p>{endpoint.description}</p>
          <p><strong>Autentizace:</strong> {endpoint.auth}</p>
          <pre className="code-block">{`Request:\n${endpoint.auth}\n${endpoint.request}`}</pre>
          <pre className="code-block">{`Response:\n${endpoint.response}`}</pre>
        </>
      )}
    </div>
  );
})}
</section>
<section className="section">
  <h2>Endpointy rezervace pro služby / poradenství</h2>
{endpoints.map((endpoint, index) => {
  const key = `services-${index}`; // Přidání unikátního klíče
  return (
    <div key={key} className="endpoint">
      <h3
        className="endpoint-header"
        onClick={() => toggleEndpoint(key)}
        style={{ cursor: 'pointer' }}
      >
        <span className={`method ${endpoint.method.toLowerCase()}`}>{endpoint.method}</span> {endpoint.url}
      </h3>

      {openEndpoints.includes(key) && (
        <>
          <p>{endpoint.description}</p>
          <p><strong>Autentizace:</strong> {endpoint.auth}</p>
          <pre className="code-block">{`Request:\n${endpoint.auth}\n${endpoint.request}`}</pre>
          <pre className="code-block">{`Response:\n${endpoint.response}`}</pre>
        </>
      )}
    </div>
  );
})}
        </section>
        <section className="section">
          <h2>Endpointy rezervace pro restaurace / bary apod..</h2>
          {basicEndpoints.map((endpoint, index) => {
  const key = `restaurants-${index}`;
  return (
    <div key={key} className="endpoint">
      <h3
        className="endpoint-header"
        onClick={() => toggleEndpoint(key)}
        style={{ cursor: 'pointer' }}
      >
        <span className={`method ${endpoint.method.toLowerCase()}`}>{endpoint.method}</span> {endpoint.url}
      </h3>

      {openEndpoints.includes(key) && (
        <>
          <p>{endpoint.description}</p>
          <p><strong>Autentizace:</strong> {endpoint.auth}</p>
          <pre className="code-block">{`Request:\n${endpoint.auth}\n${endpoint.request}`}</pre>
          <pre className="code-block">{`Response:\n${endpoint.response}`}</pre>
        </>
      )}
    </div>
  );
})}
        </section>
        <section className="section">
          <h2>Endpointy rezervace pro booking..</h2>
          {bookingEndpoints.map((endpoint, index) => {
  const key = `booking-${index}`;
  return (
    <div key={key} className="endpoint">
      <h3
        className="endpoint-header"
        onClick={() => toggleEndpoint(key)}
        style={{ cursor: 'pointer' }}
      >
        <span className={`method ${endpoint.method.toLowerCase()}`}>{endpoint.method}</span> {endpoint.url}
      </h3>

      {openEndpoints.includes(key) && (
        <>
          <p>{endpoint.description}</p>
          <p><strong>Autentizace:</strong> {endpoint.auth}</p>
          <pre className="code-block">{`Request:\n${endpoint.auth}\n${endpoint.request}`}</pre>
          <pre className="code-block">{`Response:\n${endpoint.response}`}</pre>
        </>
      )}
    </div>
  );
})}
        </section>
      </div>
    </div>
  </div>
  );
};

export default ApiDoc;